var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCollapseCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_4776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 27 27)",
    fill: "#3772FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6123 9.18919L16.4235 13.0004C16.5009 13.0778 16.5565 13.1598 16.5902 13.2463C16.6239 13.3329 16.6407 13.4252 16.6407 13.5233C16.6407 13.6213 16.6239 13.7136 16.5902 13.8002C16.5565 13.8867 16.5009 13.9686 16.4235 14.0461L12.5991 17.8704C12.4543 18.0153 12.2778 18.0877 12.0697 18.0877C11.8616 18.0877 11.6852 18.0153 11.5403 17.8704C11.3955 17.7256 11.3252 17.5469 11.3296 17.3345C11.334 17.122 11.4086 16.9434 11.5535 16.7985L14.8287 13.5233L11.5403 10.2349C11.3955 10.09 11.323 9.91573 11.323 9.71202C11.323 9.50832 11.3955 9.33404 11.5403 9.18919C11.6852 9.04435 11.8638 8.97193 12.0763 8.97193C12.2887 8.97193 12.4674 9.04435 12.6123 9.18919Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.4838,
    y: 26.4838,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    transform: "rotate(-180 26.4838 26.4838)",
    stroke: "#3772FF",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_4776"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 27 27)",
    fill: "#3772FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCollapseCloseIcon);
export default __webpack_public_path__ + "static/media/newCollapseCloseIcon.6b3d10bc.svg";
export { ForwardRef as ReactComponent };